import {computed,observable,autorun,runInAction} from 'mobx';
import {observer} from 'mobx-react';
import InputModel from '../models/InputModel'
import SelectionModel from '../models/SelectionModel'
import CommonEntriesStore from './CommonEntriesStore'
import BaseEntriesStore from './BaseEntriesStore'
import HalbfertigAnalyseStore from './HalbfertigAnalyseStore'
import BrespaAnalyseStore from './BrespaAnalyseStore'
import OutputModel from '../models/OutputModel'
import PrintOutput from "../models/PrintOutput";
import Utils from "../utils/Utils";


class OrtbetonAnalyseStore extends CommonEntriesStore{
    constructor(){
        super();
        this.hfentries = HalbfertigAnalyseStore;
        this.baseentries = BaseEntriesStore;
        this.brespaentries = BrespaAnalyseStore;
        this.bindLoaded()
    }

    bindLoaded(){
        this.updateData2 = autorun(() => {
            console.log("updating Ortbeton", this.baseentries.daten);
            if(!this.baseentries ){return}
            console.log("updating Ortbeton after",this.baseentries.daten);
            let daten = this.baseentries.daten;
            //this.brespaselection.setOptions(SelectionModel.createOptionsFromObjectArray(daten.brespaplatten),0);
            let felder = this.baseentries.eingabefelder.ortbeton;
            if(!felder){return}

            for (let key in felder) {
                if( this.hasOwnProperty( key ) ) {
                    //console.log("setting: ", key)
                    runInAction(() => {
                        this[key].value = felder[key].value;
                        this[key].einheit = felder[key].einheit;
                        this[key].disabled = !felder[key].editable;
                        this[key].title = felder[key].title;
                    });

                }
            };
            this.entries.push(this.entries.pop())
            //this.calcKosten()
        });
    }
    title = "Einzelpositionen"

    @observable
    hfentries = HalbfertigAnalyseStore;
    @observable
    baseentries = BaseEntriesStore;
    @observable
    brespaentries = BrespaAnalyseStore;

    @observable
    systemschalung = new InputModel('Systemschalung ein- und ausschalen',1,'');
    @observable
    konventionelle_schalung = new InputModel('Konventionelle Schalung',1,'');
    @observable
    putzen_unterseite = new InputModel('Putzen und Streichen der Unterseite',1,'');
    @observable
    krankosten = new InputModel('Krankosten',1,'');
    @observable
    miete_schalung = new InputModel('Miete Schalung',1,'');
    @observable
    lohnkosten = new InputModel('Lohnkosten',1,'');

    @observable personal_montage = new InputModel('Personal Montage',"enthalten","St.",true,false,null,true);
    @observable stahl_eingebaut = new InputModel('Stahl eingebaut',"enthalten","€/kg",true,false,null,true);
    @observable joche_stellen = new InputModel('Joche stellen <br/>und ausbauen',"nicht erf.","h/St.",true,false,null,true);

    @computed get totalKostenStuetzung(){
        var out = new OutputModel("Mehrkosten für zusätzlich <br/>erforderliche Deckenauflager","Mehrkosten für zusätzlich <br/>erforderliche Deckenauflager",0.0,'€/m²');
        return out;
    }

    @computed get randschalung(){
        let k = this.lohnkosten ;
        return  new InputModel("lfd. m <br/>Randschalung <br/>(20 bis 32 cm)",0.45 * this.lohnkosten.value +5 ,''+k.einheit);
    }

    @computed get totalValueBrespa(){
        var out =  new OutputModel("Gesamtkosten für " + this.baseentries.dicke_erforderlich_brespa.value +' cm Decke',"Gesamtkosten für" + this.baseentries.dicke_erforderlich_brespa.value +' cm Decke',0.0,'€/m²');
        return out;
    }

    get totalDicke(){
        return this.baseentries.totalDicke
    }

    @observable entries = [
        this.systemschalung,
        this.personal_montage,
        this.stahl_eingebaut,
        this.miete_schalung,
        this.joche_stellen,
        this.krankosten,
        this.putzen_unterseite
    ];

    print_systemschalung= null;
    print_randschalung= null;
    print_mattenbewehrung= null;
    print_stahlbewehrung= null;
    print_betonc20= null;

    print_zeit_bewehrung= null;
    print_zeit_betonieren= null;
    print_zeit_pumpe= null;
    print_abziehen= null;
    print_schalungaussp= null;
    print_zeit_schalung_einaus= null;


    print_mehrkostenauflager= null;
    print_krankosten= null;
    print_endbehandlungunten= null;



    print_zeit_total = 0;
    print_material_total = 0;
    needsStuetzung = false;


    print_dauerherstellung = null;


    calckosten = autorun(() => {
        if(!this.baseentries || !this.baseentries.eingabefelder.ortbeton ){

            return
        }
        this.print_zeit_total = 0;
        this.print_material_total = 0;
        let deckenfl = this.baseentries.deckenflaeche.value;
        let toofat  = (this.baseentries.dickeforderlichob.value - this.brespaentries.plattendicke.value > 8);
        let numeinsaetze = this.baseentries.anzahldecken.value;
        let bew_unten_eq_sp = this.hfentries.bew_unten_eq_sp * 1.1;
        let bew_unten_eq_brespa = this.hfentries.bew_unten_eq_brespa * 1.1;
        let bew_oben_eq_sp = this.hfentries.bew_oben_eq_sp;
        let bew_oben_eq_brespa = this.hfentries.bew_oben_eq_brespa;

        let stabbew_eq_sp = (bew_oben_eq_sp + bew_unten_eq_sp) * 0.3;
        let stabbew_eq_brespa = (bew_oben_eq_brespa + bew_unten_eq_brespa) * 0.3;
        let mattenbew_eq_sp = bew_unten_eq_sp + bew_oben_eq_sp - stabbew_eq_sp;
        let mattenbew_eq_brespa = bew_unten_eq_brespa + bew_oben_eq_brespa - stabbew_eq_brespa;

        let betonmenge_eq_sp = this.baseentries.erf_deckendicke / 100 *1.05
        let betonmenge_eq_brespa= this.brespaentries.plattendicke.value / 100 *1.05

        let erfdicke = this.baseentries.erf_deckendicke;

        let kosten_bew_eq_sp = stabbew_eq_sp * this.baseentries.baustahlpreisStab.value + mattenbew_eq_sp * this.baseentries.baustahlpreisMatten.value;
        let kosten_bew_eq_brespa = stabbew_eq_brespa * this.baseentries.baustahlpreisStab.value + mattenbew_eq_brespa * this.baseentries.baustahlpreisMatten.value;
        let kosten_beton_eq_sp = this.baseentries.erf_deckendicke * this.baseentries.betonpreis.value / 100.0;
        let kosten_beton_eq_brespa = this.brespaentries.plattendicke.value * this.baseentries.betonpreis.value / 100.0;
        let kosten_schalung = this.miete_schalung.value;

        let kosten_einsaetze = this.hfentries.kosten_einsaetze ;
        let bew_einbauen_eq_sp = ((stabbew_eq_sp + mattenbew_eq_sp)*this.lohnkosten.value/1000.0)*this.baseentries.bewehrung_einbauen.value;
        let bew_einbauen_eq_brespa = ((stabbew_eq_brespa + mattenbew_eq_brespa)*this.lohnkosten.value/1000.0)*this.baseentries.bewehrung_einbauen.value;

        let schalung_einaus = this.systemschalung.value * this.lohnkosten.value;
        let aussparungen = this.hfentries.aussparungen;

        let beton_einbauen_eq_sp = this.baseentries.betonieren_transportbeton.value * this.lohnkosten.value * this.baseentries.erf_deckendicke/100;
        let beton_einbauen_eq_brespa = this.baseentries.betonieren_transportbeton.value * this.lohnkosten.value * this.brespaentries.plattendicke.value/100;
        let flaeche_abziehen = this.hfentries.flaeche_abziehen;
        let putz = this.putzen_unterseite.value;

        let m_krankosten = 6+(erfdicke -20)*0.002875*this.krankosten.value
        let m_krankosten_eq_brespa = 6+(this.brespaentries.plattendicke.value-20)*0.002875*this.krankosten.value;

        let randschalung_meter = this.baseentries.anzahldecken.value* (this.baseentries.geblaenge.value+this.baseentries.gebbreite.value)*2;
        let kostenrandschalung = randschalung_meter * this.baseentries.randschalung_eingabe.value / this.baseentries.deckenflaeche.value;


        this.print_systemschalung = new PrintOutput(Utils.rAndF(kosten_schalung)+ " €/m²",Utils.rAndFNoDec(deckenfl)+" m²" , Utils.rAndF(kosten_schalung*deckenfl),"€");
        this.print_material_total += kosten_schalung*deckenfl;
        this.print_randschalung = new PrintOutput(Utils.rAndF(randschalung_meter)+" m" ,Utils.rAndF(this.baseentries.randschalung_eingabe.value)+ " €/m", Utils.rAndF(this.baseentries.randschalung_eingabe.value*randschalung_meter),"€");
        this.print_material_total += this.baseentries.randschalung_eingabe.value*randschalung_meter;
        let mbw = toofat ? mattenbew_eq_brespa : mattenbew_eq_sp;
        this.print_mattenbewehrung = new PrintOutput(Utils.rAndF(mbw)+" kg/m²" ,Utils.rAndF(this.baseentries.baustahlpreisMatten.value)+ " €/kg x "+Utils.rAndFNoDec(deckenfl)+" m²", Utils.rAndF(this.baseentries.baustahlpreisMatten.value*mbw*deckenfl),"€");
        this.print_material_total += this.baseentries.baustahlpreisMatten.value*mbw*deckenfl;
        let sbw = toofat ? stabbew_eq_brespa : stabbew_eq_sp;
        this.print_stahlbewehrung = new PrintOutput(Utils.rAndF(sbw)+" kg/m²" ,Utils.rAndF(this.baseentries.baustahlpreisStab.value)+ " €/kg x "+Utils.rAndFNoDec(deckenfl)+" m²", Utils.rAndF(this.baseentries.baustahlpreisStab.value*sbw*deckenfl),"€");
        this.print_material_total += this.baseentries.baustahlpreisStab.value*sbw*deckenfl;
        this.print_betonc20 = new PrintOutput(Utils.rAndF(erfdicke/100.0)+" m³/m²" ,Utils.rAndF(this.baseentries.betonpreis.value)+ " €/m³ x "+Utils.rAndFNoDec(deckenfl)+" m²", Utils.rAndF(this.baseentries.betonpreis.value*(erfdicke/100.0)*deckenfl),"€");
        this.print_material_total += this.baseentries.betonpreis.value*(erfdicke/100.0)*deckenfl;

        this.print_zeit_bewehrung = new PrintOutput("","", Utils.rAndF((sbw+mbw)*deckenfl/1000.0)+ " t x " + Utils.rAndF(this.baseentries.bewehrung_einbauen.value) + " h/t = " + Utils.rAndF((sbw+mbw)*deckenfl/1000.0 * this.baseentries.bewehrung_einbauen.value) + " h","",true);
        this.print_zeit_total += ((sbw+mbw)*deckenfl/1000.0) * this.baseentries.bewehrung_einbauen.value;
        this.print_zeit_betonieren = new PrintOutput("","",Utils.rAndF((erfdicke/100.0)*deckenfl)+" m³ x " +Utils.rAndF(this.baseentries.betonieren_transportbeton.value)+ " h/m³ = "+ Utils.rAndF(this.baseentries.betonieren_transportbeton.value*(erfdicke/100.0)*deckenfl)+" h","",true);
        this.print_zeit_total += this.baseentries.betonieren_transportbeton.value*(erfdicke/100.0)*deckenfl;
       this.print_zeit_pumpe = new PrintOutput("","",Utils.rAndF(numeinsaetze)+" Gesch. x " + Utils.rAndF(this.baseentries.ruestzeiten_pumpe.value)+ " h/Gesch. = "+ Utils.rAndF(this.baseentries.ruestzeiten_pumpe.value*numeinsaetze*4) + " h","",true);
        this.print_zeit_total += this.baseentries.ruestzeiten_pumpe.value*numeinsaetze*4;
        this.print_abziehen = new PrintOutput("","",Utils.rAndF(this.baseentries.oberflaeche_abziehen.value) + " h/m² x "+ Utils.rAndFNoDec(deckenfl)+" m² = " + Utils.rAndF(this.baseentries.oberflaeche_abziehen.value*deckenfl)+" h","",true);
        this.print_zeit_total += this.baseentries.oberflaeche_abziehen.value*deckenfl;
        this.print_schalungaussp = new PrintOutput("","",Utils.rAndFNoDec(Math.ceil(deckenfl/10)) + " x "+ Utils.rAndF(this.baseentries.aussparungen_einbauen.value) + " h/St. = "+Utils.rAndF( this.baseentries.aussparungen_einbauen.value * Math.ceil(deckenfl/10))+" h" ,"",true);
        this.print_zeit_total += this.baseentries.aussparungen_einbauen.value * Math.ceil(deckenfl/10);
        this.print_zeit_schalung_einaus = new PrintOutput("","",Utils.rAndF(this.systemschalung.value) + " h/m² x " + Utils.rAndFNoDec(deckenfl)+" m² = "  +Utils.rAndF(this.systemschalung.value*deckenfl)+" h","",true);
        this.print_zeit_total += this.systemschalung.value*deckenfl;

        let mkk = toofat ? m_krankosten_eq_brespa : m_krankosten;
        let kk = (mkk*deckenfl/this.krankosten.value) + (numeinsaetze * this.baseentries.ruestzeiten_pumpe.value);
        console.log("kk: ",kk);
        this.print_krankosten = new PrintOutput(Utils.rAndF(kk) + " h",this.krankosten.value+" €/h",Utils.rAndF(kk *this.krankosten.value ),"€");
        console.log("putzen: ",this.putzen_unterseite.value);
        this.print_endbehandlungunten = new PrintOutput(Utils.rAndF(this.putzen_unterseite.value) + " €/m²",Utils.rAndFNoDec(deckenfl)+" m²",Utils.rAndF(this.putzen_unterseite.value*deckenfl),"€");

        let ml = this.brespaentries.max_laenge_other;
        let mgs = this.baseentries.masgebendestuetzweite;
        let geblaenge = this.baseentries.geblaenge.value;
        let gebbreite = this.baseentries.gebbreite.value;
        let num_stuetzung = Math.round(geblaenge *((geblaenge / ml) / (geblaenge / mgs) - 1) / ml );
        console.log("Stützungen", num_stuetzung);

        let kosten_stuetzung = this.baseentries.kosten_stuetzung.value * num_stuetzung * gebbreite / (geblaenge * gebbreite);

        this.needsStuetzung = (num_stuetzung*geblaenge*numeinsaetze) > 0 ;
        this.print_mehrkostenauflager = new PrintOutput(Utils.rAndFNoDec(num_stuetzung*geblaenge*numeinsaetze)+" lfd.m",Utils.rAndFNoDec(this.baseentries.kosten_stuetzung.value) + " €/lfd.m",Utils.rAndF(this.baseentries.kosten_stuetzung.value * num_stuetzung*geblaenge*numeinsaetze),"€");


        let total_brespa = kosten_bew_eq_brespa + kosten_beton_eq_brespa + kosten_schalung + kosten_einsaetze +
            bew_einbauen_eq_brespa + schalung_einaus + aussparungen + beton_einbauen_eq_brespa + flaeche_abziehen + putz +kostenrandschalung+kosten_stuetzung + m_krankosten_eq_brespa;

        let total_eq_sp = kosten_bew_eq_sp + kosten_beton_eq_sp + kosten_schalung + kosten_einsaetze +
            bew_einbauen_eq_sp + schalung_einaus + aussparungen + beton_einbauen_eq_sp + flaeche_abziehen + putz +kostenrandschalung + m_krankosten;

        this.totalKostenStuetzung.value = kosten_stuetzung;
        this.totalValue.value = total_eq_sp;
        this.totalValueBrespa.value = total_brespa;
        this.totalKostenStuetzung.value = Math.round(kosten_stuetzung);
        this.totalValueBrespaStuetzung.value = total_brespa + Math.round(kosten_stuetzung);


        console.log("Kosten der Stützungen", kosten_stuetzung);
        console.groupCollapsed("Ortbeton Kosten:::::::::::");
        console.group("Gleiche dicke wie Brespa");
        console.log("addieren von:");
        console.log("Kosten Bewehrung", kosten_bew_eq_brespa);
        console.log("Kosten Beton", kosten_beton_eq_brespa);
        console.log("Kosten Schalung", kosten_schalung);
        console.log("Kosten Einsaetze", kosten_einsaetze);
        console.log("Bewehrung einbauen", bew_einbauen_eq_brespa);
        console.log("Schalung ein aus", schalung_einaus);
        console.log("Aussparungen", aussparungen);
        console.log("Beton einbauen", beton_einbauen_eq_brespa);
        console.log("Fläche abziehen", flaeche_abziehen);
        console.log("Putz", putz);
        console.log("Randschalung", kostenrandschalung);
        console.log("Krankosten", m_krankosten_eq_brespa);
        console.log("Total Brespa", this.totalValueBrespa.value)
        console.groupEnd()
        console.group("Gleiche Spannweite");
        console.log("addieren von:");
        console.log("Kosten Bewehrung", kosten_bew_eq_sp);
        console.log("Kosten Beton", kosten_beton_eq_sp);
        console.log("Kosten Schalung", kosten_schalung);
        console.log("Kosten Einsaetze", kosten_einsaetze);
        console.log("Bewehrung einbauen", bew_einbauen_eq_sp);
        console.log("Schalung ein aus", schalung_einaus);
        console.log("Aussparungen", aussparungen);
        console.log("Beton einbauen", beton_einbauen_eq_sp);
        console.log("Fläche abziehen", flaeche_abziehen);
        console.log("Putz", putz);
        console.log("Randschalung", kostenrandschalung);
        console.log("Krankosten", m_krankosten);
        console.log("Total Spannweite", this.totalValue.value)
        console.groupEnd();
        console.groupEnd()
this.baseentries.detailEntries.push(this.baseentries.detailEntries.pop());



    },{ delay: 300 });

}
export default new OrtbetonAnalyseStore();




// WEBPACK FOOTER //
// ./src/stores/OrtbetonAnalyseStore.js